import React from 'react';
import { useTranslation } from 'react-i18next';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './ToolbarTopMobile.module.scss';
import Availability from '../../kit/atoms/Availability/Availability';
import Typography from '../../kit/atoms/Typography/Typography';
import MobileSortBtn from '../../kit/atoms/MobileSortBtn/MobileSortBtn';
import { AvailibilityOption, FacetData, SortOption } from '../../types';
import AppliedFilters from '../../components/AppliedFilters/AppliedFilters';

export interface ToolbarTopMobileProps {
    productsQty?: number;
    filteredAvailabilityOptions?: string[];
    availabilityOptions?: AvailibilityOption[];
    sortingOptions?: SortOption[];
    activeFilters?: FacetData[];
    currentSorting: string;
    currentOrder: string;
    onSortingChange?: (option: SortOption) => void;
    setSidebarOpen?: (isOpen: boolean) => void;
    handleRemoveFilter: (facetName: string, value: string) => void;
    clearAllFilters: () => void;
    handleAvailabilityOptions: (options: string[]) => void;
}

const ToolbarTopMobile: React.FC<ToolbarTopMobileProps> = ({
    productsQty,
    filteredAvailabilityOptions,
    availabilityOptions,
    sortingOptions,
    activeFilters,
    currentSorting,
    currentOrder,
    onSortingChange,
    setSidebarOpen,
    handleRemoveFilter,
    clearAllFilters,
    handleAvailabilityOptions
}) => {
    const st: CssModuleType = currentCssModule;
    const { t } = useTranslation();

    return (
        <div className={st['mobile-toolbar']}>
            <Typography variant='p'>
                {productsQty ? productsQty : ''} products
            </Typography>
            <div className={st['mobile-toolbar__buttons']}>
                <button onClick={() => setSidebarOpen(true)}>
                    <i className='fas fa-sliders-v'></i>
                    <Typography>
                        Filter{' '}
                        {activeFilters.length > 0
                            ? ` (${activeFilters.length})`
                            : null}
                    </Typography>
                </button>
                <MobileSortBtn
                    options={sortingOptions}
                    onChange={onSortingChange}
                    currentSorting={currentSorting}
                    currentOrder={currentOrder}
                />
            </div>
            <AppliedFilters
                filters={activeFilters}
                onRemoveFilter={handleRemoveFilter}
                clearAllFilters={clearAllFilters}
                mobileToolbarStyles
            />
            <Availability        
                filteredAvailabilityOptions={filteredAvailabilityOptions}
                availabilityOptions={availabilityOptions}
                handleAvailabilityOptions={handleAvailabilityOptions}
            />
        </div>
    );
};

export default ToolbarTopMobile;
